import { useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import type { AppState } from '@/types'
import { setCookie } from './utils'

export const useCookies = () => {
  const [hidden, setHidden] = useState(false)

  const embed = useSelector<AppState, boolean>(
    ({ artboard }) => artboard.isEmbed
  )

  const cookieAccepted = useMemo(
    () => document.cookie.includes('cookies=true'),
    []
  )

  const onSetCookie = () => {
    setHidden(true)

    setCookie()
  }

  return {
    hideCookies: cookieAccepted || embed,
    hidden,
    onSetCookie,
  }
}
